"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var sizes = ['small', 'medium', 'large'];

var AlertIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(AlertIcon, _React$PureComponent);

  function AlertIcon() {
    _classCallCheck(this, AlertIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(AlertIcon).apply(this, arguments));
  }

  _createClass(AlertIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["size", "color", "className"]);
      /* eslint-disable max-len */


      var svgs = {
        small: {
          viewBox: '0 0 9 9',
          path: _react.default.createElement("g", null, _react.default.createElement("path", {
            fill: color,
            d: "M3.02073961,7.75 L5.97926039,7.75 C5.86024087,8.45942834 5.24324907,9 4.5,9 C3.75675093,9 3.13975913,8.45942834 3.02073961,7.75 Z"
          }), _react.default.createElement("path", {
            fill: color,
            d: "M7.9452998,5.29686654 L8.7773501,5.85156673 C8.91644943,5.94429962 9,6.10041529 9,6.26759188 L9,6.5 C9,6.77614237 8.77614237,7 8.5,7 L0.5,7 C0.223857625,7 3.38176876e-17,6.77614237 0,6.5 L-5.55111512e-17,6.26759188 C-7.59843793e-17,6.10041529 0.0835505677,5.94429962 0.222649902,5.85156673 L1.0547002,5.29686654 C1.33289886,5.11140076 1.5,4.79916943 1.5,4.46481624 L1.5,3 C1.5,1.34314575 2.84314575,3.04359188e-16 4.5,0 C6.15685425,-3.04359188e-16 7.5,1.34314575 7.5,3 L7.5,4.46481624 C7.5,4.79916943 7.66710114,5.11140076 7.9452998,5.29686654 Z"
          }))
        },
        medium: {
          viewBox: '0 0 12 12',
          path: _react.default.createElement("g", null, _react.default.createElement("path", {
            fill: color,
            d: "M4,9.998 L4,10 C4,11.104 4.896,12 6,12 C7.104,12 8,11.104 8,10 L8,9.998 L4,9.998 Z"
          }), _react.default.createElement("path", {
            fill: color,
            d: "M10,5.93484466 L10,4.16684466 C10,2.07784466 8.484,0.216844663 6.404,0.018844663 C4.019,-0.209155337 2,1.66184466 2,3.99984466 L2,5.93484466 C2,6.58684466 1.642,7.18384466 1.057,7.47484466 L0.277,7.86284466 C0.107,7.94784466 0,8.12084466 0,8.30984466 L0,8.49984466 C0,8.77584466 0.224,8.99984466 0.5,8.99984466 L11.5,8.99984466 C11.776,8.99984466 12,8.77584466 12,8.49984466 L12,8.30884466 C12,8.11984466 11.894,7.94684466 11.725,7.86184466 L10.958,7.47684466 C10.377,7.18484466 10,6.58484466 10,5.93484466"
          }))
        },
        large: {
          viewBox: '0 0 14 14',
          path: _react.default.createElement("g", null, _react.default.createElement("path", {
            fill: color,
            d: "M4.05000906,12 L8.94999094,12 C8.71835578,13.1411202 7.70947896,14 6.5,14 C5.29052104,14 4.28164422,13.1411202 4.05000906,12 Z"
          }), _react.default.createElement("path", {
            fill: color,
            d: "M11.0932238,8.44491785 L12.7,9.65 C13.0313708,9.89852814 13.0985281,10.3686292 12.85,10.7 C12.7083592,10.8888544 12.486068,11 12.25,11 L0.75,11 C0.335786438,11 1.27060241e-13,10.6642136 1.27009514e-13,10.25 C1.26980604e-13,10.013932 0.111145618,9.79164079 0.3,9.65 L1.90677621,8.44491785 C2.22766025,8.13649565 2.43624204,7.72977786 2.5,7.29035373 L2.5,4 C2.5,1.790861 4.290861,4.05812251e-16 6.5,0 C8.709139,-4.05812251e-16 10.5,1.790861 10.5,4 L10.5,7.29035373 C10.563758,7.72977786 10.7723397,8.13649565 11.0932238,8.44491785 Z"
          }))
        }
      };
      /* eslint-enable max-len */

      var svg = svgs[size];
      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'alert-icon'),
        viewBox: svg.viewBox,
        size: size
      }, props), svg.path);
    }
  }]);

  return AlertIcon;
}(_react.default.PureComponent);

exports.default = AlertIcon;
AlertIcon.defaultProps = {
  color: 'inherit',
  size: 'medium'
};
AlertIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string,

  /**
   * Size of icon.
   */
  size: _propTypes.default.oneOf(sizes)
};